import { render, staticRenderFns } from "./LogListTable.vue?vue&type=template&id=64560cee"
import script from "./LogListTable.vue?vue&type=script&lang=js"
export * from "./LogListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports